import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ProjectGrid from './components/ProjectGrid';
import WitnessSection from './components/WitnessSection';
import Footer from './components/Footer';
import ProjectDetail from './components/ProjectDetail';
import { Project } from './types';

const App: React.FC = () => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  useEffect(() => {
    document.body.style.overflow = selectedProject ? 'hidden' : 'unset';
  }, [selectedProject]);

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <ProjectGrid onSelectProject={setSelectedProject} />
      <WitnessSection />
      <Footer />

      {selectedProject && (
        <ProjectDetail 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}
    </div>
  );
};

export default App;